/*
 * Public API Surface of inova-core
 */


export * from './breadcumb.module'
export * from './components/breadcumb.component'
export * from './models/breadcumb';

